import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-esewa-payment-success',
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1
      })),
      state('closed', style({
        opacity: 0.2
      })),
      transition('open => closed', [
        animate('2s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ],
  templateUrl: './esewa-payment-success.component.html',
  styleUrls: ['./esewa-payment-success.component.css']
})
export class EsewaPaymentSuccessComponent implements OnInit {


  params= {
    amt: 100,
    rid: "000AE01",
    pid: "ee2c3ca1-696b-4cc5-a6be-2c40d929d453",
    scd: "epay_payment"
  }

  paymentVerified: boolean = false

  propertyId: any

  voucherPath: any

  imgURL: any

  paymentDetail: any

  seoData: SeoSocialShareData = {
    title:  'Payment - Esewa',
    description: 'Esewa payment portal for Nepal Property Services.',
    image: environment.url+'/assets/logo.png'
  };

  constructor(private route: ActivatedRoute, private notification: MatSnackBar, private authService: AuthService,
    private router: Router, private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.propertyId = this.route.snapshot.params.id
    this.route.queryParams
      .subscribe(params => {
        if(params.oid && params.refId && params.amt) {
          this.params.pid = params.oid
          this.params.rid = params.refId
          this.params.amt = params.amt
          this.checkTranscation()
        }
      });
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
    if(filesize <= 8){
      this.voucherPath = image
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.imgURL = reader.result; 
      }
      this.saveVoucherImage()
    }
  }

  checkTranscation(){
    let params = {
      paymentMethod: 'esewa',
      property_id: this.params.pid,
      transaction_id: this.params.rid,
      amount: this.params.amt
    }
    this.authService.savePaymentDetails(params).subscribe(data => {
      if(data.status){
        this.paymentDetail = data.transaction
        this.paymentVerified = true
      }
    }, error => {
      if(error.status == 400){
        this.paymentVerified = true
      }
    })
  }

  saveVoucherImage(){
    let paymentDetail = Object.assign({}, this.paymentDetail)
    if(this.voucherPath){
      delete paymentDetail['id']
      delete paymentDetail['user_id']
      paymentDetail['voucherPath'] = this.voucherPath
    }
    this.authService.updatePaymentDetails(this.paymentDetail.id, paymentDetail).subscribe( data => {
      if(data.status){
        this.viewProperty()
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  viewProperty(){
    this.router.navigate(['edit-property/'+this.propertyId])
  }

}
